export default function providerForm() {
    const iContact = (form, ty) => {
        if (form) {
            form.addEventListener("submit", function (e) {
                e.preventDefault();

                let data = new FormData(form);
                const urlEncodedData = new URLSearchParams(data).toString();
                fetch("https://copay.medthink.com/icontact", {
                    method: "POST",
                    body: urlEncodedData,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                })
                    .then((response) => response.text())
                    .then((success) => {
                        console.log(success);
                        console.log("Submission was successful");
                        window.location.assign(ty);
                    });
            });
        }
    };

    iContact(
        document.getElementById("provider-form"),
        "/hcp/become-a-provider/thank-you/"
    );
}
